import { render } from "./bgCookieBanner.vue?vue&type=template&id=7495047a"
import script from "./bgCookieBanner.vue?vue&type=script&lang=js"
export * from "./bgCookieBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__